export { default as comment } from '@handlebars/comment.hbs';
export { default as commentEditor } from '@handlebars/comment-editor.hbs';
export { default as commentEditorMentionItem } from '@handlebars/comment-editor-mention-item.hbs';
export { default as commentHeader } from '@handlebars/comment-header.hbs';
export { default as commentRestriction } from '@handlebars/comment-restriction.hbs';
export { default as commentSleepUserMessage } from '@handlebars/comment-sleep-user-message.hbs';
export { default as commentSticker } from '@handlebars/comment-sticker.hbs';
export { default as commentStickerHeaderItem } from '@handlebars/comment-sticker-header-item.hbs';
export { default as commentStickerItem } from '@handlebars/comment-sticker-item.hbs';
export { default as commentStickerList } from '@handlebars/comment-sticker-list.hbs';
